import BoxContainer from '../../core/components/box/boxContainer';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import LXIcon from '../../core/components/buttons/lxIcon';
import { ReactComponent as Client } from '../../../assets/icons/selectedClient.svg';
import { useTheme } from 'styled-components';
import SizedBox from '../../core/components/box/sizedBox';
import { LXCaption, LXh1, LXh4 } from '../../core/texts/lxText';
import FlexBox from '../../core/components/box/flexBox';
import LXSmallButton from '../../core/components/buttons/lxSmallButton';
import LXSpinner from '../../core/spinner/lx_spinner';
import usePatientBoardConttoller from '../../../1_application/dashboard/patientBoardController';

const NewClient = ({
  width,
  height,
  fromDate,
  endDate,
}: {
  width: string;
  height: string;
  fromDate?: Date;
  endDate?: Date;
}) => {
  const theme = useTheme();
  const p = usePatientBoardConttoller(fromDate, endDate);

  if (p.loading)
    return (
      <BoxContainer width={width} height={height}>
        <LXSpinner></LXSpinner>
      </BoxContainer>
    );
  return (
    <BoxContainer padding="24px 30px 30px 30px" width={width}>
      <Column>
        <Row alignItems="center" justifyContent="space-between">
          <LXh4>{theme.texts.newClient}</LXh4>
          <LXCaption
            onClick={p.navigateToPatientList}
            color={theme.colors.primary500}
          >
            {theme.texts.seeAll}
          </LXCaption>
        </Row>
        <SizedBox height={28} />
        <Row alignItems="center">
          <LXIcon
            width="48px"
            icon={Client}
            backgroundColor={theme.colors.primaryBg}
          ></LXIcon>
          <SizedBox width={16}></SizedBox>
          <Row alignItems="baseline">
            <LXh1 height="32px">{p.newPatientCount}</LXh1>
            <LXCaption>{`/${p.totalPatientCount}`}</LXCaption>
          </Row>
          <FlexBox></FlexBox>
          <LXSmallButton onClick={p.navigetToAddPatient}>
            {theme.texts.plusAdd}
          </LXSmallButton>
        </Row>
      </Column>
    </BoxContainer>
  );
};

export default NewClient;
